import { Location } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LayoutService, NavbarBtn, ToolbarDetails } from 'src/app/layout/layout.service';
import { ConfigService } from 'src/app/services/config.service';
import { PrivilegesService } from 'src/app/services/privileges.service';

@Component({
  selector: 'app-servicenear-navbar',
  templateUrl: './servicenear-navbar.component.html',
  styleUrls: ['./servicenear-navbar.component.scss']
})
export class ServicenearNavbarComponent {

  constructor(
    private router: Router,
    public layoutService: LayoutService,
    private route: ActivatedRoute,
    private location: Location,
    private configService: ConfigService,
    public privilegeService: PrivilegesService,
  ) { }

  ngOnInit(): void {
  }

  get isBack() {
    const currentUrl = this.router.url;
    const backUrls = ['/serviceDetails','/purchaseEdit','/user/staffDetails','/user/add','/user/list','products','whatsnew','profile','accountInfo','changePassword','/userDetails', 'socialProfiles', 'myOtherDevices'];

    return backUrls.some(path => currentUrl.includes(path));
  }

  public openSideNav() {
    document.getElementById("mySidenav").style.width = "85%";
    document.getElementById("myCloseContainer").style.width = "15%";
    document.body.style.overflow = 'hidden'; // disable background scroll
  }

  goBack(): void {
    if (window.history.length > 1) {
      this.location.back();
    } else {
      const currentParams = this.route.snapshot.queryParams;
      this.router.navigate(['/servicenear/dashboard'], { queryParams: currentParams });
    }
  }

  public gotoPage(path) {
    if (path === '/servicenear/logout') {
      this.configService.logoutUser(false, true);
    } else {
      const currentParams = this.route.snapshot.queryParams;
      this.router.navigate([path], { queryParams: currentParams });
    }
    this.closeSideNav();
  }

  public closeSideNav() {
    document.getElementById("mySidenav").style.width = "0";
    document.getElementById("myCloseContainer").style.width = "0";
    document.body.style.overflow = ''; // restore default
  }

  public onButtonClick(btn: NavbarBtn) {
    this.layoutService.emitButtonClick(btn);
  }

}
